import type { Config } from '@/adapters/core/_contract/config';

export const CONFIG = {
    layout: 'layered-tree',
    layeredTree: {
        levelGap: 24,
        rowGap: 8,
        laneGap: 48,
    },
    showLabelsAtAllLevels: true,
    ringTree: {
        orientation: 'standing',
        radius: 48,
        radialLength: 22,
        folderRingRadius: 10,
    },
    resourcesByType: {},
    geometry: {
        rootRadius: 4.2,
        directoryRadius: 2.2,
        fileRadius: 0.9,
        renderRadiusMultiplier: 1,
        minimumSubtreeGap: 1.4,
        cameraPadding: 1.3,
    },
    visualStyle: {
        directoryColor: '#60a5fa',
        fileColor: '#94a3b8',
        rootColor: '#fbbf24',
        labelColor: '#f1f5f9',
        inactiveOpacity: 0.92,
        boundaryColors: {
            '_contract': '#f472b6',
            '_data': '#fb923c',
            '_pure': '#4ade80',
        },
    },
} as const satisfies Config;